export const LISTING_CONTAINER_ID = 'listing-container';
export const LISTING_SORTING_URL_PARAMETER = 'sorting';
export const LISTING_PAGE_URL_PARAMETER = 'page';
export const LISTING_FIRST_PAGE = 1;
